<template>
    <div class="calendar-settings-overlay">
        <div class="overlay-content">
            <h3>{{ $t('tables.calendarSettings') }}</h3>

            <!-- Renk Alanı Seçimi -->
            <label>{{ $t('tables.colorBy') }}:</label>
            <CustomPicker
                v-model="localSettings.colorByField"
                :items="dropdownFields"
                idKey="_id"
                labelKey="name"
                :title="$t('tables.selectColorField')"
                icon="palette"
            />

            <!-- Tarih Alanı Seçimi (Start) -->
            <label>{{ $t('tables.startDateField') }}:</label>
            <CustomPicker
                v-model="localSettings.calendarFieldStart"
                :items="dateFields"
                idKey="_id"
                labelKey="name"
                :title="$t('tables.selectStartDateField')"
                icon="event"
            />

            <!-- Tarih Alanı Seçimi (End) -->
            <label>{{ $t('tables.endDateField') }}:</label>
            <CustomPicker
                v-model="localSettings.calendarFieldEnd"
                :items="[{ _id: '', name: '(None)' }, ...dateFields]"
                idKey="_id"
                labelKey="name"
                :title="$t('tables.selectEndDateField')"
                icon="event"
            />

            <!-- Kartta Gösterilecek Alan Seçimi -->
            <h4>{{ $t('tables.eventCardFields') }}</h4>
            <div class="calendar-card-fields">
                <div v-for="field in fields" :key="field._id" class="field-row">
                    <a-switch
                        :checked="localSettings.cardFields.indexOf(field._id) !== -1"
                    @change="(checked) => toggleCardField(field._id, checked)"
                    />
                    <span>{{ field.name }}</span>
                </div>
            </div>

            <div class="footer">
                <SupsisButton ghost @click="$emit('close')">{{ $t('tables.cancel') }}</SupsisButton>
                <SupsisButton primary @click="handleSave">{{ $t('tables.save') }}</SupsisButton>
            </div>
        </div>
    </div>
</template>

<script>
import CustomPicker from "@/components/pickers/CustomPicker.vue";
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";

export default {
    name: "CalendarSettingsOverlay",
    components: {
        CustomPicker,
        SupsisButton
    },
    props: {
        fields: {
            type: Array,
            default: function() {
                return [];
            },
        },
        calendarSettings: {
            type: Object,
            default: function() {
                return {
                    calendarFieldStart: null,
                    calendarFieldEnd: null,
                    cardFields: [],
                    colorByField: null,
                };
            },
        },
    },
    data: function() {
        return {
            localSettings: {
                calendarFieldStart: null,
                calendarFieldEnd: null,
                cardFields: [],
                colorByField: null,
            },
        };
    },
    computed: {
        /**
         * Date/Datetime tipindeki alanları süzebiliriz
         */
        dateFields: function() {
            return this.fields.filter(function(f) {
                return f.fieldType === "datetime" || f.fieldType === "date";
            });
        },
        /**
         * Sadece static dropdown alanlarını getir
         */
        dropdownFields() {
            return this.fields.filter(f =>
                f.fieldType === "dropdown" &&
                f.options?.dropdown?.mode === "static"
            );
        },
    },
    created: function() {
        this.localSettings.calendarFieldStart = this.calendarSettings.calendarFieldStart;
        this.localSettings.calendarFieldEnd = this.calendarSettings.calendarFieldEnd;
        this.localSettings.cardFields = this.calendarSettings.cardFields.slice();
        this.localSettings.colorByField = this.calendarSettings.colorByField;
    },
    methods: {
        toggleCardField: function(fieldId, checked) {
            const idx = this.localSettings.cardFields.indexOf(fieldId);
            if (!checked && idx > -1) {
                this.localSettings.cardFields.splice(idx, 1);
            } else if (checked && idx === -1) {
                this.localSettings.cardFields.push(fieldId);
            }
        },
        handleSave: function() {
            this.$emit("saveSettings", {
                calendarFieldStart: this.localSettings.calendarFieldStart,
                calendarFieldEnd: this.localSettings.calendarFieldEnd,
                cardFields: this.localSettings.cardFields,
                colorByField: this.localSettings.colorByField,
            });
            this.$emit("close");
        },
    },
};
</script>

<style scoped lang="scss">
.calendar-settings-overlay {
    position: fixed;
    top: 0; right: 0; bottom: 0;
    width: 320px;
    background: #fff;
    box-shadow: -2px 0 6px rgba(0,0,0,.15);
    z-index: 9999;
    padding: 16px;

    .field-row {
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 8px 0;
    }

    .overlay-content {
        display: flex;
        flex-direction: column;
        height: 100%;

        label {
            margin: 8px 0;
        }

        h4 {
            margin: 16px 0 8px;
        }

        .footer {
            margin-top: auto;
            display: flex;
            justify-content: space-between;
            border-top: 1px solid #ddd;
            padding-top: 1rem;
        }
    }
    .calendar-card-fields {
        display: flex;
        flex-direction: column;
        gap: 8px;
        overflow-y: auto;
    }
}
</style>
